import { useState } from "react";

import type { LoginResponse } from "../services/auth.service";
import { buildSetupTwoFactorPath } from "../services/build-setup-two-factor-path";

const HOME_PATH = "/";

function replaceLocation(path: string): void {
  window.location.replace(new URL(path, window.location.origin));
}

export function useCompleteLogin({ resolveReturnPath }: { resolveReturnPath: () => string | null }) {
  const [twoFactorToken, setTwoFactorToken] = useState<string | null>(null);

  const completeWithReturnPath = () => {
    replaceLocation(resolveReturnPath() ?? HOME_PATH);
  };

  const applyOutcome = (response: LoginResponse) => {
    if (response.requires2FA && response.twoFactorToken) {
      setTwoFactorToken(response.twoFactorToken);
      return;
    }

    if (response.setupRequired) {
      replaceLocation(buildSetupTwoFactorPath(resolveReturnPath()));
      return;
    }

    completeWithReturnPath();
  };

  const forgetTwoFactorToken = () => {
    setTwoFactorToken(null);
  };

  return { twoFactorToken, applyOutcome, completeWithReturnPath, forgetTwoFactorToken };
}
